import {
  GET_DATA_ROOM_CUSTOM_PRICING,
  GET_DATA_ROOM_PRICING,
  GET_LAST_VISITED_ROOMS,
  GET_PM_ROOMS_PROGRESSIVELY,
  GET_PM_ROOMS,
  GET_GUEST_ROOMS_PROGRESSIVELY,
  GET_GUEST_ROOMS,
  GET_EXISTING_ROOMS_LABELS,
  GET_ROOM_LABELS,
  GET_SUBSCRIPTION_LABELS,
  GET_RECENT_ROOMS,
} from './action_types'
import { fetchRoomsByRole } from './helpers/fetchRoomsByRole'
import {
  SET_DATA_ROOM_CUSTOM_PRICING,
  SET_DATA_ROOM_CUSTOM_PRICING_ERROR,
  SET_DATA_ROOM_CUSTOM_PRICING_PENDING,
  SET_DATA_ROOM_PRICING,
  SET_DATA_ROOM_PRICING_ERROR,
  SET_DATA_ROOM_PRICING_PENDING,
  SET_GET_ROOM_LABELS_ERROR,
  SET_GET_ROOM_LABELS_PENDING,
  SET_LAST_VISITED_ROOMS,
  SET_LAST_VISITED_ROOMS_PENDING,
  SET_ROOMS_LABELS,
  SET_SUBSCRIPTION_LABELS,
  SET_SUBSCRIPTION_LABELS_ERROR,
  SET_SUBSCRIPTION_LABELS_PENDING,
  SET_RECENT_ROOMS,
  SET_RECENT_ROOMS_PENDING,
  SET_RECENT_ROOMS_ERROR,
  SET_PM_ROOMS_PENDING,
  SET_PM_ROOMS,
  SET_PM_ROOMS_PAGINATION,
  SET_PM_ROOMS_ERROR,
  SET_GUEST_ROOMS_PENDING,
  SET_GUEST_ROOMS,
  SET_GUEST_ROOMS_PAGINATION,
  SET_GUEST_ROOMS_ERROR,
  SET_EXISTING_ROOMS_LABELS_PENDING,
  SET_EXISTING_ROOMS_LABELS,
  SET_EXISTING_ROOMS_LABELS_ERROR,
  SET_PM_ABORT_CONTROLLER,
  SET_GUEST_ABORT_CONTROLLER,
  RESET_ALL_PM_ROOMS_STATE,
  RESET_ALL_GUEST_ROOMS_STATE,
} from './mutation_types'
import roomsService from '../../../services/rooms.service'

export const actions = {
  async [GET_SUBSCRIPTION_LABELS] ({ commit }, config) {
    commit(SET_SUBSCRIPTION_LABELS_PENDING, true)
    try {
      const response = await roomsService.getSubscriptionLabels(config)
      commit(SET_SUBSCRIPTION_LABELS, response.data)
    } catch (error) {
      commit(SET_SUBSCRIPTION_LABELS_ERROR, error)
      throw error
    } finally {
      commit(SET_SUBSCRIPTION_LABELS_PENDING, false)
    }
  },
  async [GET_DATA_ROOM_CUSTOM_PRICING] ({ commit }, data) {
    commit(SET_DATA_ROOM_CUSTOM_PRICING_PENDING, true)
    try {
      const response = await roomsService.getDataRoomCustomPricing(data)
      commit(SET_DATA_ROOM_CUSTOM_PRICING, response.data)
    } catch (error) {
      commit(SET_DATA_ROOM_CUSTOM_PRICING_ERROR, error)
      throw error
    } finally {
      commit(SET_DATA_ROOM_CUSTOM_PRICING_PENDING, false)
    }
  },
  async [GET_DATA_ROOM_PRICING] ({ commit }) {
    commit(SET_DATA_ROOM_PRICING_PENDING, true)
    try {
      const response = await roomsService.getDataRoomPricing()
      commit(SET_DATA_ROOM_PRICING, response.data)
    } catch (error) {
      commit(SET_DATA_ROOM_PRICING_ERROR, error)
      throw error
    } finally {
      commit(SET_DATA_ROOM_PRICING_PENDING, false)
    }
  },
  async [GET_PM_ROOMS_PROGRESSIVELY]({ dispatch, commit }, query = {}) {
    commit(RESET_ALL_PM_ROOMS_STATE)

    await dispatch(GET_PM_ROOMS, {
      ...query,
      mini: true,
      roomCounters: false,
    })
    return dispatch(GET_PM_ROOMS, {
      ...query,
      mini: false,
      roomCounters: true,
    })
  },
  async [GET_GUEST_ROOMS_PROGRESSIVELY]({ dispatch, commit }, query = {}) {
    commit(RESET_ALL_GUEST_ROOMS_STATE)

    await dispatch(GET_GUEST_ROOMS, {
      ...query,
      mini: true,
      roomCounters: false,
    })
    return dispatch(GET_GUEST_ROOMS, {
      ...query,
      mini: false,
      roomCounters: true,
    })
  },
  async [GET_PM_ROOMS]({ commit, state }, query = {}) {
    return fetchRoomsByRole({
      commit,
      state,
      role: 'pm',
      query,
      roomsServiceMethod: roomsService.getRooms,
      signalMutationType: SET_PM_ABORT_CONTROLLER,
      pendingMutationType: SET_PM_ROOMS_PENDING,
      successMutationType: SET_PM_ROOMS,
      paginationMutationType: SET_PM_ROOMS_PAGINATION,
      errorMutationType: SET_PM_ROOMS_ERROR,
    })
  },
  async [GET_GUEST_ROOMS]({ commit, state }, query = {}) {
    return fetchRoomsByRole({
      commit,
      state,
      role: 'guest',
      query,
      roomsServiceMethod: roomsService.getRooms,
      signalMutationType: SET_GUEST_ABORT_CONTROLLER,
      pendingMutationType: SET_GUEST_ROOMS_PENDING,
      successMutationType: SET_GUEST_ROOMS,
      paginationMutationType: SET_GUEST_ROOMS_PAGINATION,
      errorMutationType: SET_GUEST_ROOMS_ERROR,
    })
  },
  /**
   * @function getRooms
   * @param {Boolean} mini
   * @param {store} store
   */
  getRooms: async function ({ commit }, queryObject = {}) {
    commit('SET_PROCESSING', true)
    try {
      const response = await roomsService.getRooms(queryObject)
      commit('SET_ROOMS', response.data)
      commit('SET_LOADING_ROOMS_INFO', queryObject.mini || false)
    } catch (error) {
      commit('SET_ERROR', error)
      throw error
    } finally {
      commit('SET_PROCESSING', false)
    }
  },
  async [GET_ROOM_LABELS] ({ commit }, mnemo) {
    commit(SET_GET_ROOM_LABELS_PENDING, true)
    try {
      const response = await roomsService.getRoomLabels(mnemo)
      commit(SET_ROOMS_LABELS, response.data)
    } catch (error) {
      commit(SET_GET_ROOM_LABELS_ERROR, error)
      throw error
    } finally {
      commit(SET_GET_ROOM_LABELS_PENDING, false)
    }
  },
  async [GET_LAST_VISITED_ROOMS] ({ commit }, limit) {
    commit(SET_LAST_VISITED_ROOMS_PENDING, true)

    try {
      const response = await roomsService.getLastVisitedRooms({
        limit,
      })
      const { rooms } = response.data

      commit(SET_LAST_VISITED_ROOMS, rooms)
    } finally {
      commit(SET_LAST_VISITED_ROOMS_PENDING, false)
    }
  },
  async [GET_RECENT_ROOMS] ({ commit }, { limit, roomCounters = true }) {
    commit(SET_RECENT_ROOMS_PENDING, true)
    try {
      const response = await roomsService.getLastVisitedRooms({
        limit,
        roomCounters,
      })
      const { rooms } = response.data
      commit(SET_RECENT_ROOMS, rooms)
      const pmRooms = rooms.filter(room => room.isPM)
      const guestRooms = rooms.filter(room => !room.isPM)
      commit(SET_PM_ROOMS, pmRooms)
      commit(SET_GUEST_ROOMS, guestRooms)
    } catch (error) {
      console.error(error)
      commit(SET_RECENT_ROOMS_ERROR, error)
      throw error
    } finally {
      commit(SET_RECENT_ROOMS_PENDING, false)
    }
  },
  async [GET_EXISTING_ROOMS_LABELS]({ commit }) {
    commit(SET_EXISTING_ROOMS_LABELS_PENDING, true)
    try {
      const response = await roomsService.getExistingRoomsLabels()
      commit(SET_EXISTING_ROOMS_LABELS, response.data)
    } catch (error) {
      console.error('Error fetching existing rooms labels:', error)
      commit(SET_EXISTING_ROOMS_LABELS_ERROR, error)
      throw error
    } finally {
      commit(SET_EXISTING_ROOMS_LABELS_PENDING, false)
    }
  },
}
